
export default {
	name: "LetterLengthBoxLinks",
	props: {
		title: {
			required: true,
			type: String,
		},
		items: {
			required: true,
			type: Array,
		},
		showSeparator: {
			required: true,
			type: Boolean,
		},
	},
	computed: {
		computedTitle() {
			return this.title;
		},
		computedItems() {
			return this.items || [];
		},
		isWordsByLengthLandingPage() {
			return (
				this.$store?.getters?.[
					"navigation/isWordsByLengthLandingPage"
				] ?? false
			);
		},
	},
};
